// 从简体中文改成繁体中文的原因：因战地无疆中文展示的是繁体，没有简体，需求方要求
// 从繁体中文改成简体中文的原因：因ro仙侠中文展示的是简体，没有繁体，需求方要求
// 需求方要求乱七八糟的，无奈
// 那你创多一个语言文件不行吗？？
// lang/en.js
export default {
  copySuccess: "複製成功",
  copyFail: "複製失敗，請嘗試手動複製",
  foot: {
    termsOfService: "会员条款",
    privacyPolicy: "隐私条款",
    Notice: "注意事项",
    EmailText: "客服郵箱：",
    info: "© NEXON Korea Corp.All Rights Reserved",
    info1: "",
    info2: "",
    info3: "",
    info4: "",
    rotwilightsea:
      "© Gravity Co., LTD & Lee MyoungJin(studio DTDS). All Rights Reserved.",
    tkingdomssea:
      "Copyright© 2025 RASTAR GAMES (HK) CO., Ltd. All Rights Reserved",
  },
  notFound: {
    title: "您訪問的頁面不見了......",
    content: "即將離開本頁，",
    content2: " 秒後自動返回首頁",
    btn: "返回首頁",
  },
};
